export const addAddress2 = address2 => {
  if (!address2) return '';
  if (address2.startsWith('#')) return ` ${address2}`;
  return `, ${address2}`;
};

// from https://pe.usps.com/text/pub28/28apc_003.htm
export const UnitDesignatorsMap = {
  apartment: 'apt',
  bldg: null,
  floor: 'fl',
  suite: 'ste',
  unit: null,
};

export const UnitDesignators = Object.entries(UnitDesignatorsMap)
  .reduce((a, b) => a.concat(b))
  .filter(v => !!v);

export const UnitDesignatorsRegexp = UnitDesignators.join('|');

export const UnitMatchers = [
  // match unit + number or text, like apt 1 or suite ABC
  new RegExp(`\\s+((${UnitDesignatorsRegexp})\\s+#?[\\d\\w]+)`, 'i'),
  // match ordinal number + unit, like 3rd floor
  new RegExp(`\\s+(\\d+(st|nd|rd|th)\\s+(${UnitDesignatorsRegexp}))`, 'i'),
  // match unit numbers, like #17
  /\s+(#\d+)/,
];



// WEBPACK FOOTER //
// ./src/utilities/AddressHelper.js